import { useQuery } from 'react-query';
import { InvoiceInterface } from '../../../interfaces/invoice.interface';
import { apiRQ } from '../../api';

const getSale = async (id: string | undefined): Promise<InvoiceInterface> => {
  const resp = await apiRQ.get<InvoiceInterface>(`/invoices/${id}`);
  return resp.data;
};

export const useSale = (id: string | undefined) => {
  return useQuery<InvoiceInterface, Error>(['getSale', id], () => getSale(id), {
    enabled: id !== 'create' && !!id,
    cacheTime: 200,
    staleTime: 200,
    refetchOnWindowFocus: false,
    select: (data) => {
      if (!data) return data;
      const newData = JSON.parse(JSON.stringify(data));

      newData.currentCustomer = { ...data?.customer };
      newData.customerEmail = data?.customer?.email || data?.staticCustomer?.email;
      newData.company = data?.staticCompany || newData.company;
      newData.customer = data?.staticCustomer || newData.customer;

      return { ...newData };
    },
  });
};
